import { Zero } from 'nftx.js';
import { parseEther } from 'viem';

const calculateExitFee = (
  type: 'inventory' | 'liquidity',
  lockedUntil: number,
  vTokenAmount: bigint
) => {
  const now = Math.floor(Date.now() / 1000);

  if (now > lockedUntil) {
    return Zero;
  }

  const earlyWithdrawalPenalty = parseEther('0.1'); // 10%
  const timelock = parseEther(type === 'inventory' ? '259200' : '172800');

  const penalty =
    ((BigInt(lockedUntil) - BigInt(now)) *
      vTokenAmount *
      earlyWithdrawalPenalty) /
    timelock;

  return penalty;
};

export default calculateExitFee;
